import styled from 'styled-components'

import Button from '~/components/button'
import { color, font } from '~/styles/utils'

export const Amount = styled.div<{
  $bold?: boolean
  $discount?: boolean
}>`
  ${({ $bold }) => $bold && font('bold')};
  color: ${({ $discount }) => $discount && color('blueCreek')};
  white-space: nowrap;
`

export const NormalLine = styled.div`
  padding: 0 0 12px 0;
  ${font('demi')};
  font-size: 16px;
  line-height: 17px;
  display: flex;
  justify-content: space-between;
`

export const StyledButton = styled(Button).attrs({ type: 'plain' })`
  &&& {
    display: block;
    color: ${color('blueCreek')};
    &:disabled {
      color: ${color('mediumGrey')};
    }

    .button-content {
      display: flex;
      align-items: center;
    }
  }
`

export const PromotionDescription = styled.div`
  display: flex;
`

export const DiscountLine = styled(NormalLine)`
  text-transform: capitalize;
  ${font('base')};

  &&& {
    ${PromotionDescription} {
      display: flex;

      ${StyledButton} {
        padding: 0 0 0 16px;
      }
    }
  }
`
